import { Table } from "antd";
import React, { useState } from "react";
import CreditAccount from "./atom/CreditAccount";

const Body = ({ list, currency, users, domainBrand }) => {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const { Column } = Table;
  const [filterValue, setFilterValue] = useState("");

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">Treasury Accounts</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                {dictionary
                  ? dictionary["WO_TREASURY_ACCOUNT_IS_2020916536"]
                  : "Treasury Account is an Electronic money which exists in the ecosystem and should be underwritten by a physical money deposit. Treasury Account should be regarded as a master account from which all Sub Accounts are funded(Agent Float/Customer Wallet)."}
              </li>
            </ol>
          </div>
          <div className="ms-auto pageheader-btn" />
        </div>

        <div className="row row-sm">
          <div className="col-lg-12">
            <div className="card custom-card">
              <div className="card-body">
                <CreditAccount dictionary={dictionary} currency={currency} />
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="card custom-card">
              <div className="card-body">
                <div className="col-lg-6 col-md-6 mb-3 mt-2 pt-3 pb-3">
                  <input
                    type={"text"}
                    className="form-control px-3"
                    value={filterValue}
                    onChange={(e) => setFilterValue(e.target.value)}
                    placeholder="Search..."
                  />
                </div>
                <div className="table-responsive">
                  <Table
                    dataSource={[]}
                    className="w-100 table tbody"
                    loading={false}
                  >
                    <Column
                      title="Created Date"
                      dataIndex="createdDate"
                      key="1"
                      className=""
                    />
                    <Column
                      title="PCN"
                      dataIndex="createdDate"
                      key="2"
                      className=""
                    />
                    <Column
                      title="Cashier Name"
                      dataIndex="createdDate"
                      key="3"
                      className=""
                    />
                    <Column
                      title="Originating Country"
                      dataIndex="createdDate"
                      key="4"
                      className=""
                    />
                    <Column
                      title="Sending Amount"
                      dataIndex="createdDate"
                      key="5"
                      className=""
                    />
                    <Column
                      title="Status"
                      dataIndex="createdDate"
                      key="6"
                      className=""
                    />
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Body;
